
import {
  ADD_TO_APPLIED,
  ADD_TO_ARCHIVED,
  ADD_TO_PROGRESS,
  REMOVE_FROM_APPLIED,
  REMOVE_FROM_ARCHIVED,
  REMOVE_FROM_PROGRESS,
  SAVE_JOB, UNSAVE_JOB
} from "../actions/jobs";

import {
  GET_PROFILE_DROP_DOWN,
  POST_PROFILE_DATA,
} from "../constants/actionTypes";

const defaultState = {
  jobs: [],
  profileFilterData: [],
   savedJobs: [],
    progressJobs: [],
  appliedJobs: [],
  archivedJobs: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case POST_PROFILE_DATA:
      return {
        ...state,
        jobs: action.payload.sort((a, b) => a.name.localeCompare(b.name)),
      };
    case GET_PROFILE_DROP_DOWN:
      return {
        ...state,
        profileFilterData: action.payload,
      };
      case SAVE_JOB:
        if(state.savedJobs.find((job) => job.id === action.payload.id)){
          return state;
        }
        return{
          ...state,
          savedJobs:[...state.savedJobs,action.payload]
        }

       case UNSAVE_JOB:
        return{
          ...state,
         savedJobs: state.savedJobs.filter((job) => job.id !== action.payload),
        }

       case ADD_TO_PROGRESS:
        return  { 
          ...state, progressJobs: [...state.progressJobs, action.payload] 
        };

       case REMOVE_FROM_PROGRESS:
        return{
          ...state,
           progressJobs: state.progressJobs.filter(job => job.id !== action.payload)
        }
        
         case ADD_TO_APPLIED:
        return  { 
          ...state, 
          appliedJobs: [...state.appliedJobs, action.payload] 
        };

       case REMOVE_FROM_APPLIED:
        return{
          ...state,
           appliedJobs: state.appliedJobs.filter(job => job.id !== action.payload)
        }

         case ADD_TO_ARCHIVED:
        return  { 
          ...state, 
         archivedJobs: [...state.archivedJobs, action.payload]
        };

       case REMOVE_FROM_ARCHIVED:
        return{
          ...state,
          archivedJobs: state.archivedJobs.filter(job => job.id !== action.payload)
        }
    default:
      return { ...state };
  }

};
